// extracted by mini-css-extract-plugin
module.exports = {"article-valve":"ArticleValve_article-valve__M4P5I"};